/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum VideoSourceFormat {
    H264 = 0,
    MJPEG = 1,
    JPEG = 2,
}
